import { ClientApplication } from 'hooks/webapi/client/useApplicationQuery';
import { Offer } from 'hooks/webapi/application/useFirstLoanOfferQuery';
import createFastContext from 'hooks/createFastContext';

type BankId = {
  paymentAccounts?: Array<string>;
  sessionId?: string | null;
  error?: boolean;
  confirmed?: boolean;
};

type Store = {
  offer?: Offer;
  application?: ClientApplication;
  bankId?: BankId;
  manualIdentification?: boolean;
};

const { StoreProvider, useStore } = createFastContext<Store>({});

// TODO: Check if we can comply to this eslint rule
// eslint-disable-next-line react-refresh/only-export-components
export { StoreProvider, useStore };
